module.exports = __webpack_public_path__ + "static/media/6-countercontrol.11e5ccc.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sounds/altcoin/6-countercontrol.mp3
// module id = JmH7
// module chunks = 0